import { FiMail, FiPhone, FiCalendar } from 'react-icons/fi';

export default function ContactSection() {
  return (
    <section className="py-20 px-8 lg:px-16 bg-base-100">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <h2 className="text-3xl lg:text-4xl font-bold mb-4">
          Let's Talk
        </h2>
        <p className="text-lg opacity-70 mb-10 max-w-xl mx-auto">
          Curious how we can help your brand? Reach out — we'd love to understand your challenges.
        </p>

        {/* Contact Options */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* Email */}
          <a
            href="mailto:yash@gamgee.ai"
            className="card bg-base-200 hover:bg-base-300 transition-colors"
          >
            <div className="card-body items-center text-center">
              <FiMail className="w-8 h-8 text-primary mb-2" />
              <h3 className="font-medium">Email</h3>
              <p className="text-sm opacity-70">yash@gamgee.ai</p>
            </div>
          </a>

          {/* Phone */}
          <a
            href="tel:+918123387772"
            className="card bg-base-200 hover:bg-base-300 transition-colors"
          >
            <div className="card-body items-center text-center">
              <FiPhone className="w-8 h-8 text-primary mb-2" />
              <h3 className="font-medium">Phone</h3>
              <p className="text-sm opacity-70">+91-8123387772</p>
            </div>
          </a>

          {/* Calendar */}
          <a
            href="https://calendar.app.google/ryUHXkYQwjr8evt78"
            target="_blank"
            rel="noopener noreferrer"
            className="card bg-base-200 hover:bg-base-300 transition-colors"
          >
            <div className="card-body items-center text-center">
              <FiCalendar className="w-8 h-8 text-primary mb-2" />
              <h3 className="font-medium">Book a Call</h3>
              <p className="text-sm opacity-70">Schedule a time</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
